import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setCurrent, changeState, setHistoryDirtyBit } from '../actions/index';
import Question from './Question';
import NotesEditor from './NotesEditor';
import QuestionNav from './QuestionNav';
import QuizNav from './QuizNav';
import QuestionImage from './QuestionImage';
import QuestionHeader from './QuestionHeader';

import '../styles/Quiz.css';

class Quiz extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    if (!this.props.isQuiz) {
      this.props.changeState('init', { back: true });
    } else {
      this.props.setCurrent();
    }

    // if (!this.props.viewOnly && !this.props.historyDirtyBit) {
    //   this.props.setHistoryDirtyBit();
    // }
  }

  render() {
    return this.props.isQuiz ? (
      <ReactCSSTransitionGroup
        className="container"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >
        <div className="quiz-container">
          <div className="nav-container">
            <QuestionNav />
          </div>
          <div className="quiz-content-wrapper">
            <QuestionHeader />
            <div className="content-container">
              <div className="question-column">
                <div className="hide-not-mobile">
                  <NotesEditor />
                </div>
                <Question />
                <div className="quiz-submit-row">
                  {!this.props.viewOnly ? <QuizNav /> : null}
                </div>
              </div>
              <div className="question-column hide-on-mobile">
                <NotesEditor />
                <QuestionImage />
              </div>
            </div>
          </div>
        </div>
      </ReactCSSTransitionGroup>
    ) : null;
  }
}

// Quiz.propTypes = {
//   count: React.PropTypes.number.isRequired,
//   mode: React.PropTypes.string.isRequired,
//   questions: React.PropTypes.arrayOf(React.PropTypes.shape({
//     id: React.PropTypes.string.isRequired,
//     explanation: React.PropTypes.string.isRequired,
//     images: React.PropTypes.array.isRequired,
//   })).isRequired,
//   tags: React.PropTypes.arrayOf(React.PropTypes.shape({
//     id: React.PropTypes.string.isRequired,
//   })).isRequired,
//   fetchQuestions: React.PropTypes.func.isRequired,
// };

function mapStateToProps(state) {
  return {
    finished: state.quiz ? state.quiz.finished : null,
    viewOnly: state.quiz ? state.quiz.viewOnly : null,
    isQuiz: !!state.quiz,
    historyDirtyBit: state.filtered ? state.filtered.isDirty : true
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { setCurrent, changeState, setHistoryDirtyBit },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);



// WEBPACK FOOTER //
// ./src/containers/Quiz.js